export default {
  'page.common.trader':'交易员',
  'page.common.startChallenge':'开始挑战',
  'page.common.freeChallenge':'免费挑战',
  // footer
  'pages.footer.text1':'加入我们',
  'pages.footer.text2':'我们在全球拥有超过百万社区用户，加入我们一起交流吧',
  'pages.footer.text3':'关于我们',
  'pages.footer.text4':'公告中心',
  'pages.footer.text5':'Cookie政策',
  'pages.footer.text6':'隐私说明',
  'pages.footer.text7':'反洗钱政策',
  'pages.footer.text8':'服务条款',
  'pages.footer.text9':'社区',
  'pages.footer.text10':'Telegram社区',
  'pages.footer.text11':'Discord社区',
  'pages.footer.text12':'Findtrader公司并非经纪商，不接受任何存款。本网站仅向交易者提供模拟交易和金融市场交易相关的教育服务，不构成任何具体的投资建议。及其包含的所有信息、材料和服务（统称为“内容”）并非专门针对任何特定国家或司法管辖区的居民而设计或提供。',
  'pages.footer.text13':'公司名称',
  'pages.footer.text14':'公司地址：香港 荃灣 柴灣角街66-82 金熊工業中心 19樓AD座40B房',
  'pages.footer.text15':'注册号',
  'pages.footer.text16':'邮箱',
  // 首页
  'pages.home.banner.text1':'成为',
  'pages.home.banner.text2':'从这里开始！',
  'pages.home.banner.text3':'通过模拟挑战，赢取资助账户',
  'pages.home.banner.text4':'交易账户',
  'pages.home.banner.text5':'累计用户',
  'pages.home.banner.text6':'考核时间',
  'pages.home.banner.text7':'提供资金',
  'pages.home.banner.text8':'顶级',
  'pages.home.company.title1':'选择',
  'pages.home.company.title3':'的理由',
  'pages.home.company.tabs.title1':'实时同步',
  'pages.home.company.tabs.title2':'不限交易日',
  'pages.home.company.tabs.title3':'无点差',
  'pages.home.company.tabs.title4':'全币兑',
  'pages.home.company.tabs.title5':'多账户操作',
  'pages.home.company.text1':'我们的系统与OKX交易所的数据实现了实时同步，确保交易者始终能够获得最新的市场信息，增强订单处理的效率。',
  'pages.home.company.text2':'我们的平台实现了全天候无休的交易环境，确保交易者随时可以进入市场，进行交易。',
  'pages.home.company.text3':'这意味着交易者可以在没有额外成本的情况下进行交易，极大地减少了交易成本，提升了利润空间。',
  'pages.home.company.text4':'我们的平台支持各类币兑，使交易者能够选择最适合的交易机会，提升交易灵活性和选择空间。',
  'pages.home.company.text5':'我们的平台支持多账户同时操作，交易者可以轻松管理不同策略与资产，提高交易效率。',
  'pages.home.challenge.title1':'开始你的挑战',
  'pages.home.challenge.firstStep':'第一步',
  'pages.home.challenge.twoStep':'第二步',
  'pages.home.challenge.threeStep':'第三步',
  'pages.home.challenge.text1':'请前往官网注册并登录',
  'pages.home.challenge.text2':'根据您的经验和需求选择最合适您的挑战方案',
  'pages.home.challenge.text3':'另外，每月可以免费参与全球评估交易。',
  'pages.home.challenge.text4':'不同方案设有1-2个的获利目标，完成每项挑战后联络相应工作人员以获得奖励。',
  'pages.home.challenge.text5':'兑换奖励后继续进入下一阶段比赛。',
  'pages.home.challenge.text6':'通关后签署协议，成为Findtrader资助的交易者!',
  'pages.home.challenge.text7':'参与者无需承担交易风险或支付费用，即可获得6:4利润分红，利润超过10%可以申请双倍资金。',
  'pages.home.challenge.btn1':'获取奖励',
  'pages.home.challenge.btn2':'利润分红',
  'pages.home.product.title1':'交易目标',
  'pages.home.product.title2':'选择令你最成功的方案',
  'pages.home.account.title':'账号使用流程',
  'pages.home.account.subTitle':'了解为什么全球如此多的交易员选择泛德作为他们首选的Prop Firm',
  'pages.home.account.firstStep.title':'注册主账号',
  'pages.home.account.firstStep.text':'扫描邀请码或访问我们的官网，使用邮箱注册。自行设置主账号密码（非系统生成）。注册成功，邮箱即为主账号的唯一凭证。',
  'pages.home.account.twoStep.title':'获得挑战账户',
  'pages.home.account.twoStep.text':'登录主账号后，通过以下途径申请挑战账户：个人中心 → 购买评估页面（付费挑战账户）；个人中心 → 个人资料/账户信息页面（免费月赛账户等）；注：关键新挑战账户的 账号及系统密码，均自动发送至主账号邮箱。',
  'pages.home.account.threeStep.title':'管理挑战账户',
  'pages.home.account.threeStep.text':'登录主账号进入个人中心→仪表板：一键切换不同挑战账户，独立操作数据；挑战账户及密码可在仪表板获取及修改密码',
  'pages.home.account.fourStep.title':'登录交易终端',
  'pages.home.account.fourStep.text':'终端登录操作：下载 官方APP 或 PC交易端；使用 挑战账户名 + 密码（来自主邮箱）登录；开始交易操作',
  'pages.home.userInfo.title':'受到世界各地交易者的信赖',
  'pages.home.userInfo.subTitle':'了解为什么全球如此多的交易员选择Findtrader作为他们首选的PROP FIRM',
  'pages.home.community.title':'加入我们的精英交易社区',
  'pages.home.community.subTitle':'受益于以一个志同道合的个人组成的社区，大家通过交易获得成功。',


  // 关于
  'pages.about.banner.title':'的故事',
  'pages.about.banner.text':'2018：在算法主导的世界中押注人类\n' +
      '2018 年，加密货币市场在兴奋与恐慌之间摇摆不定，在ICO和算法军备竞赛的狂热中，我们注意到交易所没有衡量的东西——信号和交易之间的情感延迟。这才是真正的优势所在。于是几个志同道合的交易员想去证明：真正的波动性并不在图表中，而是在交易员自身尚未开发的潜力中。\n' +
      '我们深知，成功的交易员不仅需要资金支持，更需要系统的培训和实战经验。\n' +
      '因此，决心创建一个不仅能为交易员提供资金支持的平台，还能帮助他们实现自我价值。',
  'pages.about.banner.text2':'我们秉持着一个简单的信念：\n' + '卓越的交易员是后天培养的，而非天生的。',
  'pages.about.vision.title':'我们的愿景',
  'pages.about.vision.text':'打破进入加密市场的壁垒，降低学习门槛，让更多的人能够接触和理解加密货币交易。\n' +
                      '加密技术的未来不仅仅关乎技术；还关乎交易背后的人。\n' +
                      '（The future of crypto isn’t just about technology; it’s about the people behind the trades.）',
  'pages.about.advantage.title':'的三大支柱',
  'pages.about.advantage.item1.title':'深度交易所集成',
  'pages.about.advantage.item1.text':'行情报价来自币安/OKX 等一级合作伙伴的真实数据',
  'pages.about.advantage.item2.title':'以人才为中心的融资',
  'pages.about.advantage.item2.text':'我们的动态扩展计划奖励绩效，而不仅仅是通过挑战。',
  'pages.about.advantage.item3.title':'全面发展',
  'pages.about.advantage.item3.text':'从入门训练到高级算法交易，我们与您共同成长。',
  'pages.about.milestone.title':'的里程牌',
  'pages.about.milestone.text1':'2018年   研究交易心理——发现 90% 的失败源于情绪缺口，而非技术缺口。',
  'pages.about.milestone.text2':'2019年开始进行交易员投资   已部署 200 万美元 | 已资助 37 位交易员\n' +
      '我们早期的尝试证明了这一点：\n' +
      '通过正确的培训，天赋可以超越算法。推出了我们的第一个利润分享模型——交易员保留了 70% 的收益 ！',
  'pages.about.milestone.text3':'2022年开始设计模拟交易系统 ',
  'pages.about.milestone.text4':'2023年  与交易所合作   正式与OKX 合作   让我们的交易者与机构投资者同场竞技   获得更加真实的交易体验感。',
  'pages.about.milestone.text5':'2024年    正式上线模拟交易系统     完成$80M里程碑',
  'pages.about.milestone.text6':'2025年计划   上线交易员动态测评系统',
  'pages.about.button':'加入',

  // 产品-挑战规则
  'pages.rule.productIntroduction.title':'比赛介绍',
  'pages.rule.productIntroduction.text':'Findtrader是一款模擬加密貨幣交易的策略比賽。\n交易員將扮演一名虚擬貨幣投資者，在與真實市場的同步的交易虚擬幣市場中進行投資、交易和管理自己的資產组合。通過智慧和策略，交易員可以積累財富，成爲虚擬幣中的傑出交易員。通過模擬考的交易員，會獲得我們提供的顶級交易所的真實賬户，並獲得真實獎金。\n每月，參與者將有一次免費參與比賽的機會，體驗交易的刺激。若在免費模式中未能取得成功，參與者可參考官方網站提供的價格表，選择合適的付費套餐繼續参與比賽。',
  'pages.rule.operation.title':'交易操作',
  'pages.rule.operation.text':'1.本金虧損5%或者賬戶最大動熊回撒6%時，強平所有倉位，選手則被淘汰;\n' +
      '2.單日結算盈利大於初始本金 2%的，按 2%計算後，有效盈利達到對應賬戶規定的盈利目標，即爲通過比賽:\n' +
      '3.比賽支持現貨、合約交易品種，不限制現貨及合約倍数;不限制隔夜，不限制倉位;',
  'pages.rule.operation.firstStep':'资产管理',
  'pages.rule.operation.firstStep.text':'交易員可以查看自己的资產組合，包括持有的虚擬幣種類和数量。\n' +
      '交易員可以設置止損和止盈點，系统將自動執行賣出操作以保護利潤或減少損失。',
  'pages.rule.operation.twoStep':'资产管理',
  'pages.rule.operation.twoStep.text':'交易員可以查看自己的资產組合，包括持有的虚擬幣種類和数量。\n' +
      '交易員可以設置止損和止盈點，系统將自動執行賣出操作以保護利潤或減少損失。',
  'pages.rule.operation.threeStep':'说明',
  'pages.rule.operation.threeStep.text':'交易員可以查看自己的资產組合，包括持有的虚擬幣種類和数量。\n' +
      '交易員可以設置止損和止盈點，系统將自動執行賣出操作以保護利潤或減少損失。',
  'pages.rule.precautions.title1':'账户',
  'pages.rule.precautions.title2':'注意事项',
  'pages.rule.precautions.title3':'说明',
  'pages.rule.precautions.text':'由於通訊系統繁忙、中斷、電力中斷、計算機、網絡、風控等各種系統故障所導致的交易出現延遲、中斷或錯誤，我們不承擔任何責任和損失;雙方任何一方因政府禁令、工等、現行生效的法律法規變更，軟件調整無法繼續正常使用，洪水、爆炸、雷電、地震、電信通訊線路中斷等以及其他不可抗力事件的影響，從而全部或者部分不能履行本協議的，我們不承擔任何责任和失。\n' +
      '考無隔夜限制，僅限交易各品種的現貨交易和合約交易。',

  // 产品-个人挑战
  'pages.personal.banner.title':'个人挑战',
  'pages.personal.banner.text':'速度与精确是短线的灵魂，但永远让止损跑在利润前面。\n 保罗·都铎·琼斯(Paul Tudor Jones)',
  'pages.personal.setting.rule.title':'挑战设置原理',
  'pages.personal.setting.rule.text':'1.本金損失不得超過 5% 或賬戶最大動熊回撤超過達到 6%，如果違反  平台規定的規則，則您的所有部位將被強制關閉。\n'+
                                '2.單日結算盈利大於初始本金 2% 的，按 2% 計算後，有效盈利達到對應賬戶規定的盈利目標，即爲通過比赛。\n'+
                               '3.比賽支持現貨、合約交易品種，倍数 1:5;不限制隔夜，不限制倉位。\n'+
                              '4.比賽分爲兩個階段，首階段盈利達到 25% 即通關，二階段達到 15% 即通。最快 20 個交易日達成。\n'+
                              '5.利潤分成比例 5:5。',

  // 合伙人计划
  'pages.partnership.title1':'合伙人计划',
  'pages.partnership.title2':'为什么选择我们的计划？',
  'pages.partnership.title3':'三步快速启动',
  'pages.partnership.subTitle':'分享行业机会，获得持续高额返佣',
  'pages.partnership.email':'如何成为合伙人?\n 当月成功推荐10位付费用户(如订阅交易资金账户等)，即\n可自动升级为正式合伙人',
  'pages.partnership.explanation.text':'行业最高分成--20-30%佣金碾压同业(平均仅12-18%)\n'+
  '被动收入自动化:用户续费/升级自动计入你的收益\n'+
  '受邀用户通过挑战获得实盘账户后，该用户收益的5%将给予合伙人(实盘账户被收回，奖励终止)。',
  'pages.partnership.start.first.title':'1.注册',
  'pages.partnership.start.first.text':'提交基本信息，获取专属推广ID',
  'pages.partnership.start.two.title':'2.推广',
  'pages.partnership.start.two.text':'通过社交媒体/社群/行业峰会分享',
  'pages.partnership.start.three.title':'3.提现',
  'pages.partnership.start.three.text':'每月自动结算至您的钱包',
  'pages.partnership.contactUs':'联系我们的商务团队，加入全球顶级加密货币合伙人网络!\n' +
      '商务对接:business@findtrader.io\n' +
      '本计划最终解释权归Findtrader公司所有，禁止作弊行为',

  // 招募交易员
  'pages.trader.title1':'精英加密交易员计划',
  'pages.trader.subTitle':'成为我们的加密交易精英: \n获得最高$1200.000资金支持',
  'pages.trader.btn1':'加入交易员',
  'pages.trader.btn2':'加入',
  'pages.trader.title2':'我们希望您可以提供以下资料',
  'pages.trader.text1':'1.交易记录验证\n' +
      '提供6-12个月完整交易记录，包括交易策略、盈利情況和风险管理。\n' +
      '2.身份与合规文件\n' +
      '政府签发ID（护照/驾照+身份证双验证）\n' +
      '法律合规声明：签署《反洗钱声明》与《合规交易承诺证书》声明您过去没有违反任何金融法规或参与非法交易活动。\n' +
      '3.专业资质证明(非必须但优先)\n' +
      '金融类执照(如CFAFRM/证券从业资格)加密行业认证(如CME比特币期货交易证书)。',
  'pages.trader.title3':'我们能为您提供',
  'pages.trader.start.first.title':'资金与收益',
  'pages.trader.start.first.text':'阶梯式资金池：通过审核即获$50K起，表现优异者可管理$1M+\n' +
      '行业最高分成：首年80%分成，盈利可随时分紅，你能自由支配属于你的收益',
  'pages.trader.start.two.title':'交易基础设施',
  'pages.trader.start.two.text':'零延迟接入：直接连接OKX的机构\n' +
      '专业工具包：免费提供TradingView Premium',
  'pages.trader.start.three.title':'成长与背书',
  'pages.trader.start.three.text':'机构资金对接：业绩达标者可接触$10M+专业资方\n' +
      '策略代销权：优质策略将打包进入机构白名单，获得跟单分成',
  'pages.trader.text2':'证明您的优势，获得精英资本。',


  // 下载
  'pages.download.h5.title':'移动端APP',
  'pages.download.h5.text':'您的掌上机构级交易终端，7x24小时市场动态尽在掌握\n' +
      '跨平台同步：与PC端数据实时互联无缝切换\n' +
      '便携交易：一键平仓/快速撤单等移动优化操作流\n' +
      '便携图表：手机优化K线工具,双指缩放查看深度数据',
  'pages.download.pc.text':'为职业交易员打造的全功能桌面终端，无缝对接全球主流交易所流动性\n' +
      '更清晰的行情展示：K线图、深度图等在高分辨率屏幕上更易观察细节\n' +
      '高效操作：可以更快速地设置止损、止盈订单，进行批量交易、条件单设置等高级操作\n' +
      '适用场景：专业交易高频交易/长期盯盘与交易',
  'pages.download.pc.title':'PC端交易终端',
  'pages.download.pc.btn':'PC交易端',


  // 个人资料
  'pages.profile.tabs.personal':'个人信息',
  'pages.profile.tabs.account':'账户信息',
  'pages.profile.account.doing':'进行中',
  'pages.profile.account.undo':'未开始',
  'pages.profile.account.apply':'申请',
  'pages.profile.account.elite-competition':'精英赛',
  'pages.profile.account.elite-competition.short':'短线赛账户',
  'pages.profile.account.elite-competition.good':'优选赛账户',

  'pages.profile.account.base-account':'基础账户',
  'pages.profile.account.pro-account':'进阶账户',

  'pages.profile.tabs.verification':'认证信息',
  'pages.profile.account.monnthAccount':'月赛账户',
  'pages.profile.account.short':'短赛线账户',
  'pages.profile.account.preferred':'优选赛账户',
  'pages.profile.account.tooltip':'精英赛每月仅能二选一参与',




  // 登录页
  'pages.layouts.userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '发送验证码',
  'pages.getCaptchaSecondText': '秒后重新发送',
  'pages.login.rememberMe': '记住我',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',

  //FAQ
  'pages.faq.type.title':'Findtrader Trader FAQ\'s',
  'pages.faq.type.sub-title':'选择问题类型以便于查找',
  'pages.faq.type.placeholder':'搜索相关文章',
  'pages.faq.type.link-text':'篇文章',
  'pages.faq.list.title':'交易信息',

  //仪表盘
  'pages.pannel.welcome': '欢迎回来',
  'pages.pannel.accountInfo': '当前权益',
  "pages.pannel.actual-rate-return":'实际收益率',
  'pages.pannel.assess': '评估',
  'pages.pannel.total-profit': '总利润',
  'pages.pannel.total-volume': '总交易量',
  'pages.pannel.account-overview': '提交总量',
  'pages.pannel.aximum-drawdown': '最大回撤',
  'pages.pannel.maxday-loss': '每日最大亏损',
  'pages.pannel.profit-target': '盈利目标',
  'pages.pannel.maximum-loss': '本金最大亏损',
  'pages.pannel.current-equity': '当前权益',
  'pages.pannel.target-equity': '目标权益',
  'pages.pannel.transaction-record': '交易记录',
  'pages.pannel.high-water-level': '高水位',
  'pages.pannel.day-before': '上一日结算权益',

//购买评估
  'pages.purchase.evaluation': '评估',
  'pages.purchase.orderInfo': '账单信息',
  //订单详情
  'page.order.details': '订单详情',
  'page.order.payType': '选择付款方式',
  // EARN
  'pages.title.points-account': '积分账户',
  'pages.total-points': '积分总额',
  'pages.recent-changes': '近期变动',
  'pages.invitation-code': '邀请码',
  'pages.invitation-count': '邀请总人数',
  'pages.btn.sharing-link': '复制分享链接',
  'pages.title.points-redemption': '积分兑换',
  'pages.btn.redemption': '确认兑换',
  'pages.title.purchase-rewards': '购买账户奖励',
  'pages.basic-account': '基础账户',
  'pages.advanced-account': '高级账户',
  'pages.professional-account': '专业账户',
  'pages.title.invitation-reward': '邀请朋友奖励',
  'pages.invitation-register': '朋友注册',
  'pages.invitation-pay': '朋友付费购买',
  'pages.invitation-account': '朋友购买账户',
  'pages.tabs.title.integral': '积分明细',
  'pages.tabs.title.invitation': '邀请记录',
  'pages.columns.integral.type': '变动类型',
  'pages.columns.integral.count': '变动数量',
  'pages.columns.integral.description': '变动描述',
  'pages.columns.integral.time': '变动时间',
  'pages.columns.invitation.uid': 'UID',
  'pages.columns.invitation.name': '用户名',
  'pages.columns.invitation.email': '邮箱地址',
  'pages.columns.invitation.registerTime': '注册时间',
  'pages.columns.invitation.payTime': '购买时间',

  // payout
  'pages.tabs.title.statistics': '利润统计',
  'pages.tabs.title.withdrawCash': '利润提现',
  'pages.statistics.title': '利润分成',
  'pages.statistics.profitsTotal': '利润总额',
  'pages.statistics.todayProfits': '今日利润',
  'pages.statistics.withdrawableProfits': '可提现利润',
  'pages.statistics.WithdrawnProfits': '已提现利润',
  'pages.statistics.record.title': '分成记录',
  'pages.columns.statistics.account': '通关账户',
  'pages.columns.statistics.totalProfit': '盈利总额',
  'pages.columns.statistics.profitToday': '今日盈利',
  'pages.columns.statistics.divisionRatio': '分成比例',
  'pages.columns.statistics.dividendAmount': '分红金额',
  'pages.columns.statistics.time': '变动时间',








  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
};
